import { createStackNavigator } from '@react-navigation/stack'
import React from 'react'
import { OPLStackParamList } from './OPLStackParamList'
import { OPLScreen } from './OPLScreen'
import {
  OPLBusinessDocument,
  OPLEditingDocument,
  OPLFormDocument,
  OPLSubDocument,
  OPLViewDetailDocument
} from './opl-document'
import { OPLEditingSignature, OPLSignature, OPLViewDetailSignature } from './opl-signature'
import { OPLStackContext } from './OPLStackContext'
import { pipe } from 'fp-ts/lib/function'
import { ErrorHandling, Permission, RBAC } from '@pulseops/common'
import { OPLReport } from './opl-report'

const stack = createStackNavigator<OPLStackParamList>()
export const OPLStack = () => {
  const permissions: string[] = pipe(RBAC.permissionWithNoCache, ErrorHandling.runDidMount([]))
  return (
    <OPLStackContext.Provider value={{ userPermissions: permissions }}>
      <stack.Navigator initialRouteName="OPLScreen" screenOptions={{ headerShown: false }}>
        <stack.Screen name="OPLScreen" component={OPLScreen} />
        {permissions.includes(Permission.ViewSubMenuDocitemOPLSDSubMenuDoc) && (
          <stack.Screen name="OPLBusinessDocument" component={OPLBusinessDocument} />
        )}
        {permissions.includes(Permission.ViewSignatureOPLSD) && (
          <stack.Screen name="OPLSignature" component={OPLSignature} />
        )}
        {permissions.includes(Permission.ViewOPLSDEditDocument) && (
          <stack.Screen name="OPLEditingDocument" component={OPLEditingDocument} />
        )}
        {permissions.includes(Permission.ViewOPLSDViewDetailDoc) && (
          <stack.Screen name="OPLViewDetailDocument" component={OPLViewDetailDocument} />
        )}
        {permissions.includes(Permission.ViewOPLSDEditSignature) && (
          <stack.Screen name="OPLEditingSignature" component={OPLEditingSignature} />
        )}
        {permissions.includes(Permission.ViewOPLSDViewDetailSign) && (
          <stack.Screen name="OPLViewDetailSignature" component={OPLViewDetailSignature} />
        )}
        {permissions.includes(Permission.LinkSubMenuDocsOPLSD) && (
          <stack.Screen name="OPLSubDocument" component={OPLSubDocument} />
        )}
        {permissions.includes(Permission.ViewSubMenuDocitemOPLSDSubMenuDoc) && (
          <stack.Screen name="OPLFormDocument" component={OPLFormDocument} />
        )}
        {permissions.includes(Permission.ViewOPLSDViewLogHardcopy) && (
          <stack.Screen name="OPLReport" component={OPLReport} />
        )}
      </stack.Navigator>
    </OPLStackContext.Provider>
  )
}
